import React from "react";
import Image from "next/legacy/image";
import PropTypes from "prop-types";
import * as Text from "@/components/text";
import { twMerge } from "tailwind-merge";

export default function Award({
  title = "",
  description = "",
  size = "sm",
  theme = "light",
  className,
  compact = false,
  customStyle = "",
}) {
  const awardStyle = twMerge(
    "flex items-center text-center justify-center lg:w-[240px] md:w-[180px] sm:w-[140px] h-[120px]",
    className
  );
  return (
    <div
      className={awardStyle}
      style={{
        backgroundImage:
          'url("/next_assets/img/film/award/Left.svg") ,url("/next_assets/img/film/award/Right.svg")',
        backgroundRepeat: "no-repeat, no-repeat",
        backgroundPosition: "left, right",
        backgroundSize: "contain, contain",
      }}
    >
      <div className="flex w-[100px] flex-col items-center justify-center">
        <div className="pb-1">
          <Text.Label fontWeight="bold" size={size}>
            {title || null}
          </Text.Label>
        </div>
        {description ? (
          <Text.Body size={size} className="text-center">
            {description}
          </Text.Body>
        ) : null}
      </div>
    </div>
  );
}

Award.propTypes = {
  title: PropTypes.string,
  size: PropTypes.oneOf(["sm", "lg"]),
  theme: PropTypes.oneOf(["light", "dark"]),
};

const badges = {
  badge: "/next_assets/img/film/badge/ama_badge_white.png",
  bookmark: "/next_assets/img/film/badge/ama_bookmark.png",
};
